import { render } from "./Translation.vue?vue&type=template&id=08ff88ea&scoped=true"
import script from "./Translation.vue?vue&type=script&lang=js"
export * from "./Translation.vue?vue&type=script&lang=js"

import "./Translation.vue?vue&type=style&index=0&id=08ff88ea&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ff88ea"]])

export default __exports__